import Spinner from 'src/javascripts/components/utilities/Spinner';
import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';
import {filterTypeahead} from 'src/javascripts/components/typeaheads/TypeaheadBloodhounds';

export default class ReportsIndex {

  constructor() {}

  render() {
    const accountUrl = $('body').attr('data-account-url');

    const existingParams = new URLSearchParams(window.location.search);

    // Reload with attrs
    let reloadWithSelectedParams = function() {
      let url = '/' + accountUrl + '/reports';
      let params = {};
      params['user_id'] = $('#reports_table').attr('data-filters-user-id');
      params['client_id'] = $('#reports_table').attr('data-filters-client-id');
      params['year'] = $('#reports_table').attr('data-filters-year');
      params['quarter'] = $('#reports_table').attr('data-filters-quarter');
      params['archived'] = $('#reports_table').attr('data-filters-archived');
      params['is_system'] = $('#reports_table').attr('data-filters-is-system');
      params['as'] = 'true';

      if (existingParams.get('report_scope') == 'report_template'){
        params['report_scope'] = 'report_template';
      }
      Turbo.visit(url + '?' + $.param(params));
    }

    // On filter select
    $('.reports-filter').bind('typeahead:beforeselect typeahead:autocomplete', function(ev, suggestion) {

      // Prevent default
      ev.preventDefault();

      // Hide tooltip
      $('.tooltip').tooltip('hide');

      // Set value to symbol if a fund; otherwise value
      let val = suggestion;

      // Create/update filter
      let attr = $(this).attr('data-attr');
      $('#reports_table').attr('data-filters-' + attr, val);
      reloadWithSelectedParams();

      // Blur typeahead
      $(this).blur();

    });


    // On selecting archived
    $('.reports-radio').on('change', function(ev, suggestion) {
      let val = $(this).val()
      $('#reports_table').attr('data-filters-archived', val);
      reloadWithSelectedParams();
    })

    // On selecting system templates
    $('.reports-radio-system-template').on('change', function(ev, suggestion) {
      let val = $(this).val()
      $('#reports_table').attr('data-filters-is-system', val);
      reloadWithSelectedParams();
    })

    // On selecting a user
    $('#users_search').bind('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
      let uids = suggestion.record_id;
      $('#reports_table').attr('data-filters-user-id', uids);
      reloadWithSelectedParams();
    })

    // On selecting a client
    $('#clients_search').bind('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
      $('#reports_table').attr('data-filters-client-id', suggestion.record_id);
      reloadWithSelectedParams();
    })

  }

}